export const SMART_REFERENCE = /\\\{\{|\\\}\}|\{\{([^{}]*)\}\}|\{\{|\}\}/g;
export const emptySmartPrompt = () => ({
  version: 1,
  text: "",
  variables: [
    {
      key: "empresa",
      label: "Empresa",
      type: "text",
      source: "company.name",
      required: true,
    },
  ],
  values: {},
});
export const escapeSmartText = (value) =>
  String(value).replace(/\{\{|\}\}/g, (match) => `\\${match}`);
export const templateSmartPrompt = (origin = {}) => ({
  version: 1,
  text: origin.instructions || "",
  variables: (origin.variables || []).map((variable) => ({
    ...variable,
    source:
      variable.source ||
      (variable.key === "empresa" ? "company.name" : "agent"),
  })),
  values: {},
});
export const usedSmartKeys = (text) =>
  Array.from(String(text).matchAll(SMART_REFERENCE))
    .filter((match) => !match[0].startsWith("\\") && match[1] !== undefined)
    .map((match) => match[1]);
export const smartValue = (document, variable, companyName = "", companyValues = []) =>
  Object.prototype.hasOwnProperty.call(document.values, variable.key)
    ? document.values[variable.key]
    : variable.source === "company.name"
    ? companyName
    : variable.source === "company.variable"
    ? companyValues.find(item => item.id === variable.companyVariableId)?.value ?? ""
    : variable.default ?? "";

export const smartPromptErrors = (
  document,
  companyName = "",
  minLength = 50,
  companyValues = []
) => {
  const errors = [];
  const add = (key, message) => {
    if (!errors.some((error) => error.key === key))
      errors.push({ key, message });
  };
  for (const variable of document.variables.filter(v => v.source === "company.variable")) {
    const shared = companyValues.find(v => v.id === variable.companyVariableId);
    if (!shared || shared.type !== variable.type) add(variable.key, `Selecione uma variável desta empresa para ${variable.label}.`);
  }
  const text = document.text.replace(SMART_REFERENCE, (match, key) => {
    if (match.startsWith("\\")) return match.slice(1);
    const variable = document.variables.find((item) => item.key === key);
    if (!variable) {
      add(
        key || "",
        key
          ? `Variável desconhecida: ${key}.`
          : "Complete ou remova o marcador inválido."
      );
      return match;
    }
    const value = smartValue(document, variable, companyName, companyValues);
    if (String(value).trim() === "" && variable.required)
      add(key, `Preencha ${variable.label}.`);
    else if (
      String(value).trim() &&
      ((variable.type === "number" && !Number.isFinite(Number(value))) ||
        (variable.type === "boolean" && typeof value !== "boolean") ||
        (variable.type === "select" &&
          !(variable.options || []).includes(String(value))))
    )
      add(key, `Revise o valor de ${variable.label}.`);
    return String(value);
  });
  if (text.trim().length < minLength || text.length > 20000)
    add(
      "",
      `As instruções preenchidas devem ter entre ${minLength} e 20.000 caracteres.`
    );
  return errors;
};

export const smartTextToContent = (text) => ({
  type: "doc",
  content: String(text)
    .split("\n")
    .map((line) => {
      const content = [];
      let start = 0;
      for (const match of line.matchAll(SMART_REFERENCE)) {
        if (match[1] === undefined) continue;
        if (match.index > start)
          content.push({ type: "text", text: line.slice(start, match.index) });
        content.push({ type: "smartValue", attrs: { variableKey: match[1] } });
        start = match.index + match[0].length;
      }
      if (start < line.length)
        content.push({ type: "text", text: line.slice(start) });
      return { type: "paragraph", content };
    }),
});

export const smartContentToText = (document) =>
  (document.content || [])
    .map((paragraph) =>
      (paragraph.content || [])
        .map((node) =>
          node.type === "smartValue"
            ? `{{${node.attrs.variableKey}}}`
            : node.type === "hardBreak"
            ? "\n"
            : node.text || ""
        )
        .join("")
    )
    .join("\n");
